import {
  productBoxWideSettings,
  ProductBoxWideSettings
} from '../../../bps/components/productBoxWide/productBoxWideSettings';

productBoxWideSettings.flags.whitelistImage = ['takeAndPayBenefitText', 'free', 'award', 'stoerer'];
productBoxWideSettings.flags.whitelistConversion = [];

export {productBoxWideSettings, ProductBoxWideSettings};
